var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('main-header'),_c('div',{staticClass:"container-wrapper md-layout-row"},[_c('router-view')],1),_c('main-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }